import { auth } from './firebase';
import { getBackendUrl } from './apiUrls';

async function getAuthorizationHeaders() {
  await auth?.authStateReady?.();
  const token = await auth?.currentUser?.getIdToken();
  if (!token) {
    throw new Error('Your Firebase session is unavailable. Sign in again.');
  }
  return {
    Authorization: `Bearer ${token}`,
  };
}

async function readError(response) {
  const payload = await response.json().catch(() => null);
  return payload?.error || `Request failed (${response.status}).`;
}

export async function getBugReport(reportId) {
  const response = await fetch(
    `${getBackendUrl()}/api/bug-reports/${encodeURIComponent(reportId)}`,
    {
      headers: await getAuthorizationHeaders(),
    }
  );
  if (!response.ok) {
    throw new Error(await readError(response));
  }
  const payload = await response.json();
  return payload.report;
}

export async function getBugReportScreenshot(reportId, { download = false } = {}) {
  const response = await fetch(
    `${getBackendUrl()}/api/bug-reports/${encodeURIComponent(reportId)}/attachment${download ? '?download=1' : ''}`,
    {
      headers: await getAuthorizationHeaders(),
    }
  );
  if (!response.ok) {
    throw new Error(await readError(response));
  }
  return response.blob();
}
